import { useState } from "react";
import linkedinLogo from "../../assets/images/splashLoader.png";

const MedicalRadarLoader = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center medicalRadarLoader-wrapper">
      <img
        src={linkedinLogo}
        alt="Ophthalmology Radar Logo"
        className={`medicalRadarLoader-logo ${
          imageLoaded ? "medicalRadarLoader-visible" : "medicalRadarLoader-hidden"
        }`}
        onLoad={() => setImageLoaded(true)}
      />

      {imageLoaded && (
        <div className="medicalRadarLoader-bar">
          <div className="medicalRadarLoader-barAnimated"></div>
        </div>
      )}
    </div>
  );
};

export default MedicalRadarLoader;
